import React from 'react'
import MicroFrontend from "../MicroFrontend"

const SearchWidget = ({ data }) => {
    return (
        <MicroFrontend
            data={data}
            name="SearchWidget"
        />
    )
}

export default (SearchWidget);